import { Card, Checkbox } from 'antd'
import { AdminCModal, CButton } from 'app/components/Common'
import React, { useState } from 'react'
import { COLORS } from 'app/constants'
import AnnouncementUpdateImage from './AnnouncementUpdateImage'
import EventInput from 'app/adminpages/AdminEvents/EventInput'
import { awsUploadImage } from 'utils/awsImageStorage'
import { useNotice } from 'app/hooks/Events/notice'
import { View } from 'styles/reactnative'
import { RichTextUpdateEditor } from 'app/components/'

const AnnouncementUpdateModal = ({ item, showModal, setShowModal }) => {
	const { updateNotice } = useNotice()

	const [images, setImages] = useState<any>([])
	const [apiImages, setApiImages] = useState<any>(
		JSON.parse(item?.images) || []
	)

	const [title, setTitle] = useState(item?.title)
	const [content, setContent] = useState(item?.content)
	const [isFixed, setIsFixed] = useState(item?.is_fixed === 1 || item?.is_fixed === true)

	const updateForm = async () => {
		let resultImages: any = []
		if (images?.length) {
			resultImages = await Promise.all(
				images.map(async (file, index) => {
					const resultImage = await awsUploadImage(
						{ file: file?.originFileObj },
						index + 1,
						'profile',
						'user'
					)
					return resultImage
				})
			)
		}
		await updateNotice({
			id: item.id,
			title: title,
			content: content,
			images: [
				...resultImages.filter(Boolean),
				...apiImages.filter(Boolean),
			],
			isFixed: isFixed
		})

		setShowModal(!showModal)
	}
	return (
		<AdminCModal width={1000} show={showModal} setShow={setShowModal}>
			<Card title="수정" style={{ height: '100%' }}>
				<EventInput
					value={title}
					setValue={setTitle}
					name={'제목'}
					placeholder={'제목'}
				/>

				<RichTextUpdateEditor
					content={content}
					setContent={setContent}
				/>

				<View style={{ marginTop: 16 }}>
					<Checkbox checked={isFixed} onChange={e => setIsFixed(e.target.checked)}>
						고정공지로 설정
					</Checkbox>
				</View>

				{/* <AnnouncementUpdateImage
					apiImages={apiImages}
					setApiImages={setApiImages}
					images={images}
					setImages={setImages}
				/> */}

				<View>
					<CButton
						title={'수정'}
						onClick={updateForm}
						style={{
							marginTop: 20,
							background: COLORS.primary,
							width: 200,
							height: 30,
							color: COLORS.white,
							alignSelf: 'center',
							bottom: 20,
						}}
					/>
				</View>
			</Card>
		</AdminCModal>
	)
}

export default AnnouncementUpdateModal
